import { match } from 'react-router'
import history from '../../../history'
import { useIntl, defineMessages } from 'react-intl'
import { AppLayout } from '../../../App/Layout/AppLayout'
import { AirDna } from '../../../Components/shared/AirDna'
import shortTermRentalBg from '../assets/short-term-rental-bg.png'
import shortTermRentalBgLight from '../assets/short-term-rental-bg-light.png'
import { Box, Flex, Text, Heading, LinkButton, Link, useTheme } from '@homebotapp/hb-react-component-catalog'
import { EstimatedMonthlyPaymentBreakdownCustomerDM } from '../../../Components/homeSearch/ListingDetails/EstimatedMonthlyPayment/EstimatedMonthlyPaymentBreakdown/EstimatedMonthlyPaymentBreakdownCustomerDM/EstimatedMonthlyPaymentBreakdownCustomerDM'
import { useAppSelector } from '../../../store/hooks'
import { HomeSearchFooter } from '../../../Components/homeSearch/HomeSearchFooter/HomeSearchFooter'
import { SEARCH_PATH_HELPERS } from '../../../constants/navigation'

export const MSG = defineMessages({
  backToCalculators: {
    id: 'ShortTermRentalCalculator.backToCalculators',
    defaultMessage: 'Back to Calculators'
  },
  estimateRentalIncome: {
    id: 'ShortTermRentalCalculator.estimateRentalIncome',
    defaultMessage: 'Estimate your rental income'
  },
  seeWhatYouCouldEarn: {
    id: 'ShortTermRentalCalculator.seeWhatYouCouldEarn',
    defaultMessage: 'See how much you could potentially earn by renting a home on Airbnb'
  },
  enterHomeAddress: {
    id: 'ShortTermRentalCalculator.enterHomeAddress',
    defaultMessage: 'Enter a home address'
  },
  calculate: {
    id: 'ShortTermRentalCalculator.calculate',
    defaultMessage: 'Calculate rental income'
  },
  tryAnotherAddress: {
    id: 'ShortTermRentalCalculator.tryAnotherAddress',
    defaultMessage: 'Try another address'
  }
})

const AIR_DNA_STATE_KEY = 'shortTermRentalCalculator'

export interface ShortTermRentalCalculatorProps {
  match: match<{ buyerId?: string }>
}

export const ShortTermRentalCalculator = ({ match }: ShortTermRentalCalculatorProps) => {
  const intl = useIntl()
  const { theme } = useTheme()
  const airDna = useAppSelector(state => state.airDna)?.[AIR_DNA_STATE_KEY]

  return (
    <AppLayout loading={false} enableAgentDropdown match={match}>
      <Box mb={24}>
        <Box
          mb={16}
          px={[5, null, 20]}
          py={[5, null, 10]}
          backgroundSize='cover'
          backgroundPosition='center'
          backgroundImage={
            airDna?.params ? undefined : theme.isLightThemeType ? shortTermRentalBgLight : shortTermRentalBg
          }
        >
          <Flex mb={16} mx='auto' maxWidth='1400px' direction='column' gap={4}>
            <Flex>
              <LinkButton
                mb={4}
                flex='0 0 auto'
                size={['sm', null, null, 'md']}
                onClick={() => history.push(SEARCH_PATH_HELPERS.calculators.buildPath(match.params.buyerId))}
                tracking={{
                  guid: 'jKz7PN4qhSBuZ9orkKEheH',
                  descriptor: 'Back to Calculators',
                  ui_context: 'Short Term Rental Calculator Page'
                }}
              >
                {intl.formatMessage(MSG.backToCalculators)}
              </LinkButton>
            </Flex>
            <Heading as='h1' size={['md', null, null, 'xl']} textAlign='left' fontWeight={800} m={0}>
              {intl.formatMessage(MSG.estimateRentalIncome)}
            </Heading>
            <Text size={['sm', null, null, 'md']}>{intl.formatMessage(MSG.seeWhatYouCouldEarn)}</Text>
            {airDna?.params && (
              <Link mb={4} fontWeight={600} href={`/calculators/${match.params.buyerId}/short-term-rental-calculator`}>
                {intl.formatMessage(MSG.tryAnotherAddress)}
              </Link>
            )}
            <AirDna stateKey={AIR_DNA_STATE_KEY} />
          </Flex>
        </Box>
        <EstimatedMonthlyPaymentBreakdownCustomerDM buyerId={match.params.buyerId} />
      </Box>
      <HomeSearchFooter />
    </AppLayout>
  )
}
